import { useEffect, useState } from "react";
import { T, TF } from "react-translator-component";
import { Box, Typography, Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GCBackButton from "../components/GreenCity/GCBackButton";
import ButtonArrow2 from "../components/GreenCity/ButtonArrow2";
import dayjs from "dayjs";
import LoadingModal from "../components/LoadingModal";
import { useSelector } from "react-redux";
import appServices from "../services/app-services/appServices";

const CancelRequestsPage = () => {
  const navigate = useNavigate();
  const groupInfo = useSelector((state: any) => state.gcGroup);

  const [cancelRequests, setCancelRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [accountInfo, setAccountInfo] = useState<any>();

  const getCancelRequests = async () => {
    try {
      setLoading(true);
      const res = await appServices.getCancelRequestsOfGroup(groupInfo.id);
      setCancelRequests(res?.post_event_users);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };
  const navigateToPaymentDetails = (userPaymentDetail: any) => {
    navigate("/refundeventfee", {
      state: {
        postEventUserId: userPaymentDetail.id,
      },
    });
  };

  useEffect(() => {
    getCancelRequests();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getGroupBalance = async () => {
    try {
      const res = await appServices.getGroupBalance(groupInfo?.id);
      setAccountInfo(res?.wallet_information?.balance?.money?.amount);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getGroupBalance();
  }, []);
  return (
    <Box>
      <LoadingModal visible={loading} handleClose={() => {}} />

      <div
        style={{
          paddingTop: 100,
          paddingBottom: "12px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        }}
      >
        <GCBackButton onClick={() => navigate(-1)} />
        <Box component="div" style={styles.topButtonContainer}>
          <Box sx={{ display: "flex", gap: "5px" }}>
            <Avatar
              sx={{ width: 30, height: 30 }}
              alt="Remy Sharp"
              src={groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : ''}
            />
            <Typography style={{ marginTop: "5px", fontWeight: "bold" }}>
              {T("event_cancel_settlement")}
            </Typography>
          </Box>
        </Box>
      </div>
      <Box
        sx={{
          backgroundColor: "#F4F4F4",
          width: "100%",
          paddingTop: "10px",
          padding: "10px 15px",
        }}
      >
        {TF(T("group_page_balance"), accountInfo ?? "")}
      </Box>
      <Box sx={{ padding: "10px 15px" }}>
        <Typography
          sx={{
            borderBottom: "2px solid #86BB57",
            marginTop: "10px",
            textAlign: "left",
            fontSize: "15px",
          }}
        >
          {T("cancel_request_pending_event")}
        </Typography>
        <Box sx={{ marginTop: "30px" }}>
          {cancelRequests?.map((item: any, index: number) => {
            const fixedJsonString = item?.application_details ?
              item.application_details.replace(/=>/g, ":").replace(/nil/g, "null") : '[]'; // Convert Ruby-style to JSON
            const detail = JSON.parse(fixedJsonString);
            let cancelDate = detail[0]?.cancelledApplicationDate;
            return (
              <ButtonArrow2
                key={index}
                title={item?.event_title}
                desc={TF(T("cancel_request_date"),
                  dayjs(cancelDate).format("YYYY年M月D日 (ddd)")
                )}
                onClick={() => {
                  navigateToPaymentDetails(item);
                }}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  eventPostingIcon: {
    background: "#FF3B00",
    borderRadius: "50%",
    padding: "3px 6px 3px 6px",
    color: "white",
  },

  topButtonContainer: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    marginTop: 10,
    paddingLeft: 16,
    paddingRight: 16,
  },

  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    marginTop: "20px",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
  },
};

export default CancelRequestsPage;
